import { render, staticRenderFns } from "./PurchasePromotionCard.vue?vue&type=template&id=8c74df0a&"
import script from "./PurchasePromotionCard.vue?vue&type=script&lang=js&"
export * from "./PurchasePromotionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports